import { RichtextModel } from "@courses-pm2/api"
import { Fragment } from "react";

type Props = {
  model: RichtextModel;
}

const PUNCTUATION_REGEX = /[.,!?]\s*$/;

export function Caption(props: Props): React.JSX.Element | null {
  if (!props.model.displayCaptionAbove && !props.model.displayCaptionBelow) {
    return null;
  }

  const subCaptionLabels = [
    !!props.model.caption?.label && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.label }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.label)}
      />
    ),
    !!props.model.caption?.authorOrArtist && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.authorOrArtist }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.authorOrArtist)}
      />
    ),
    !!props.model.caption?.year && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.year }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.year)}
      />
    ),
    !!props.model.caption?.creditLine && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: `© ${props.model.caption.creditLine}` }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.creditLine)}
      />
    ),
    !!props.model.caption?.country && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.country }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.country)}
      />
    ),
    !!props.model.caption?.duration && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.duration }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.duration)}
      />
    ),
    !!props.model.caption?.numberOfPages && (
      <span
        className="span"
        dangerouslySetInnerHTML={{ __html: props.model.caption.numberOfPages }}
        data-comma={!PUNCTUATION_REGEX.test(props.model.caption.numberOfPages)}
      />
    ),
  ].filter((it): it is React.JSX.Element => !!it);

  return (
    <div className="caption">
      {!!props.model.title && (
        <h3 className="title">
          <span dangerouslySetInnerHTML={{ __html: props.model.title }} />
        </h3>
      )}
      {subCaptionLabels.length > 0 && (
        <div className="subCaption">
          {subCaptionLabels.map((label, index) => (
            <Fragment key={index}>
              {label}
              {index < subCaptionLabels.length - 1 &&
                (label.props["data-comma"] === true ? ", " : " ")}
            </Fragment>
          ))}
        </div>
      )}
      {!!props.model.description && (
        <span
          className="description"
          dangerouslySetInnerHTML={{ __html: props.model.description }}
        />
      )}

      <style jsx>{`
          .caption {
            margin: 0 0 2em 0;
            line-height: 1.5;

            &:empty {
              display: none;
            }

            & :global(.title) {
              margin: 0;
              display: block;
            }

            & :global(.subCaption) {
              margin: 1em 0 0 0;
            }

            & :global(.description) {
              margin: 1em 0 0 -1px;
              display: block;
              font-style: italic;
            }

            & :global(.span) {
              display: inline;
              font-size: 0.9em;
            }
          }
        `}</style>
    </div>
  );
}
